import { useQueryClient, useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { pm2SitemapStore } from '@pm2/sitemap-utils';
import { pm2ConfigStore } from '@pm2/store';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { getBookshelfFavouritesQuery } from './get-bookshelf-favourites.query.js';

function useDeleteBookFavourite(book) {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  const configStore = pm2ConfigStore.useStore();
  const sitemapStore = pm2SitemapStore.useStore();
  return useMutation(removeBookFavourite(client, notifier, user, book, configStore, sitemapStore));
}
const removeBookFavourite = (client, notifier, user, book, configStore, sitemapStore) => {
  return {
    mutationKey: ["user-area/bookshelf-favourites/remove", user?.id, book.id],
    mutationFn: async () => {
      if (!user) {
        return;
      }
      await axios.delete(`${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/Favorites?userID=${user.id}&learningObjectID=${book.id}`);
    },
    onMutate: async () => {
      const books = client.getQueryData(getBookshelfFavouritesQuery.queryKey({
        user,
        configStore,
        sitemapStore,
        portalId: configStore.getState().config.id
      }));
      const bookIndex = books?.findIndex(it => it.id === book.id) ?? -1;
      client.setQueryData(getBookshelfFavouritesQuery.queryKey({
        user,
        configStore,
        sitemapStore,
        portalId: configStore.getState().config.id
      }), previous => previous?.filter(it => it.id !== book.id));
      await client.cancelQueries({
        queryKey: getBookshelfFavouritesQuery.queryKey({
          user,
          configStore,
          sitemapStore,
          portalId: configStore.getState().config.id
        })
      });
      return {
        book,
        index: bookIndex
      };
    },
    onError: (error, input, ctx) => {
      client.setQueryData(getBookshelfFavouritesQuery.queryKey({
        user,
        configStore,
        sitemapStore,
        portalId: configStore.getState().config.id
      }), previous => {
        if (!ctx?.book) {
          return previous;
        }
        previous?.splice(ctx.index, 0, ctx.book);
        return previous;
      });
      notifier.notify({
        id: "user-area/favourites/remove/error",
        type: "error",
        body: `Noget gik galt da vi forsøgte at fjerne din favorit. Prøv igen om lidt.`
      });
    }
  };
};

export { useDeleteBookFavourite };
//# sourceMappingURL=delete-bookshelf-favourite.mutation.js.map
